export var CollisionMode = /*#__PURE__*/function (CollisionMode) {
  CollisionMode["absorb"] = "absorb";
  CollisionMode["bounce"] = "bounce";
  CollisionMode["destroy"] = "destroy";
  return CollisionMode;
}(CollisionMode || {});